import { render } from "./customizerconfiguration.vue?vue&type=template&id=a0f04f9e"
import script from "./customizerconfiguration.vue?vue&type=script&lang=js"
export * from "./customizerconfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__